import styles from './BlockPage.module.scss';
import { BCCbutton } from 'bccbusiness-ui-components'
import bccLogoIcon from '../assets/icons/bcc_logo.svg';
import attentionIcon from '../assets/icons/attention.svg';
import { useEffect, useState } from 'react';

export const BlockPage = () => {
  const [description1, setDescription1] = useState('Мы восстанавливаем работу сайта.');
  const [description2, setDescription2] = useState('Обновите страницу немного позднее.');

  useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await fetch('/business-lock-screen-ui/message/error');
      if (response.ok) {
        const data = await response.json();
        setDescription1(data.description1);
        setDescription2(data.description2);
      } else {
        console.error('Error fetching data');
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

    fetchData();
  }, []);

  return <div className={styles['block-page']}>
    <img className={styles['icon-logo']} src={bccLogoIcon} alt="BCC Business" />
    <div className={styles.content}>
      <img className={styles['icon-attention']} src={attentionIcon} alt="Alert" />
      <h1 className={styles.title}>Сайт временно не работает</h1>
      <div>
        <p className={styles.text}>
          {description1}
        </p>
        <p className={styles.text}>
          {description2}
        </p>
      </div>
      <div className={styles['btn-form']}>
      <BCCbutton className={styles.btn} onClick={() => { window.location.href = '/'; }}>
          <p className={styles['btn-text']}>Обновить страницу</p>
        </BCCbutton>
      </div>
    </div>
  </div>
};
